import * as httpProtocol from './httpProtocol';
import { logError } from '../../utils/httpClientUtil';
import { getAppConfig } from '../../services/init/appConfig';
const option = {
    requireCorrelationId: true,
    stringifyPostData: false,
    parseResult: false,
    authenticationType: httpProtocol.AuthenticationTypes.Graph
};
export function generateReportEmbedToken(reportData) {
    const endpoint = '/view/generateReportEmbedToken';
    const post = httpProtocol.post(endpoint, option);
    const body = {
        groupId: reportData.groupId,
        reportId: reportData.reportId,
        datasetId: reportData.datasetId
    };
    return post.addQueryEntry('version', getAppConfig('apiVersion')).setData(body).request().catch((error)=>{
        logError('generateReportEmbedToken', error);
        return Promise.resolve(null);
    });
}
